import _ from 'lodash'

// do not expose this
const globalContext = window.GLOBAL_CONTEXT ? JSON.parse(JSON.stringify(window.GLOBAL_CONTEXT)) : {}

/** @see https://github.com/darkskyapp/string-hash/ */
const simpleHash = (key) => {
  let hash = 5381
  let i = key.length

  while (i) {
    hash = (hash * 33) ^ key.charCodeAt(--i)
  }

  // hash will be [0 - 4294967295]

  // make highest bit always 1
  // use >>> to convert to unsigned int
  hash = (hash | 4294967296) >>> 0
  return hash.toString(36).toUpperCase() // base36+
}
// do another clone and freeze for feature toggles for modification protection
const featureToggles = Object.freeze(_.clone(_.get(globalContext, 'HFT', {})))
export const FT = (flag, defaultValue = false) => {
  return _.get(featureToggles, simpleHash(flag), defaultValue)
}
export { FT as isFeatureEnabled }

export const isFeatureEnabledBySupportAccount = (flag, supportAccountId = 0, defaultAccounts = []) => {
  const ft = FT(flag, defaultAccounts)
  if (Array.isArray(ft)) {
    return ft.includes(+supportAccountId)
  }
  return ft === true
}

FT.bySupportAccount = isFeatureEnabledBySupportAccount

export const GLOBAL_CONTEXT = Object.freeze(Object.defineProperties(globalContext, {
  isFeatureEnabled: { value: FT },
  FT: { value: FT },
  get: {
    value: (path, defaultValue) => _.get(GLOBAL_CONTEXT, path, defaultValue)
  },
  has: {
    value: path => _.has(GLOBAL_CONTEXT, path)
  },
}))

export { getLoginUrl, redirectToLogin, showLoginDialog, setupAxiosInterceptors } from './setupAxiosInterceptors'

// remove the original global since we kept the freezed clone
if (!globalContext.DEBUG) {
  delete window.GLOBAL_CONTEXT
}
